// extracted by mini-css-extract-plugin
export default {"infoBox":"infoBox__txUlc","infoIcon":"infoIcon__NbykJ","dismissInfo":"dismissInfo__3G+fF"};